/* global R7Insight */
import get from 'lodash.set';
// Selectors
import { makeSelectProfileValue } from '../../services/auth/selectors';

// Environment
const { REACT_APP_VERSION } = process.env;

export const logentries = (store) => (next) => (action) => {
    const state = store.getState();
    const email = makeSelectProfileValue('email')(state);

    const debuggingData = {
        email,
        version: REACT_APP_VERSION
    };

    // Ignore any redeux form actions
    if (/^@@redux-form\//.test(action.type)) {
        return next(action);
    }
    if (/^@@router\//.test(action.type)) {
        // Log all routing changes
        R7Insight.log(debuggingData, action);
    } else if (action.meta && action.meta.logentries) {
        if (action.meta.logentries === 'info') {
            R7Insight.info(debuggingData, action);
        } else if (action.meta.logentries === 'warning') {
            R7Insight.warn(debuggingData, action);
        } else if (action.meta.logentries === 'error') {
            R7Insight.error(debuggingData, action);
        } else {
            R7Insight.log(debuggingData, action);
        }
        // Capture all redux errors as warnings
    } else if (action.error) {
        // Remove Authorization header from logs
        const actionCopy = Object.assign({}, action);
        const authorization = get(
            actionCopy,
            'payload.config.headers.Authorization'
        );
        if (authorization) {
            delete actionCopy.payload.config.headers.Authorization;
        }
        R7Insight.error(debuggingData, actionCopy);
    }

    return next(action);
};
